import { render } from "./TwoPeople.vue?vue&type=template&id=309f62c8&scoped=true"
import script from "./TwoPeople.vue?vue&type=script&lang=js"
export * from "./TwoPeople.vue?vue&type=script&lang=js"

import "./TwoPeople.vue?vue&type=style&index=0&id=309f62c8&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-309f62c8"]])

export default __exports__